import { registerStore } from '@wordpress/data';
import reducer from './reducer';
import * as selectors from './selectors';
import * as actions from './actions';
import * as api from './api';

registerStore('core/actions', { actions, selectors, reducer });
export { api };
